import {config} from "@/constants/config";
import type {TResponseRequest} from "@/interfaces/http.interface";
import httpRequest from "@/providers/http/request.http";
import {buildQueryUrl} from "@/providers/http/request.instance";
import {type PaginatedResult, normalizePagination} from "@/utils/pagination";

export interface AuditLogEntry {
  id: string;
  entityType: string;
  entityId: string;
  action: string;
  previousData: Record<string, unknown> | null;
  newData: Record<string, unknown> | null;
  ip: string | null;
  deviceFingerprint: string | null;
  systemUserId: string | null;
  createdAt: string;
}

export type AuditLogListResult = PaginatedResult<AuditLogEntry>;

interface AuditLogFilters {
  page?: number;
  limit?: number;
  entityType?: string;
  entityId?: string;
  action?: string;
  systemUserId?: string;
  fromDate?: string;
  toDate?: string;
}

export const getAuditLogsService = async (
  filters: AuditLogFilters = {}
): Promise<TResponseRequest<AuditLogListResult>> => {
  const raw = await httpRequest.get<AuditLogEntry[]>({
    url: buildQueryUrl(`${config.apiBaseUrl}/bo/audit-log`, filters as Record<string, unknown>),
  });
  if (!raw.data || !raw.pagination) return {...raw, data: undefined};
  return {...raw, data: {items: raw.data, pagination: normalizePagination(raw.pagination)}};
};
